module.exports = __webpack_public_path__ + "img/card_img_6.1a116fb7.png";